import Vue from 'vue';
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist/dist/umd';

import request from './modules/request.js'

// import { config } from '../api/config.js';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    request
  },
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: { 
  },
  plugins: [vuexLocal.plugin]
})
